import { type I18nLocale, t } from '@ardoq/i18n';
import { ScheduleType, WeekOptionValues } from './types';

export const getWeekDayLabel = (
  i18nLocale: I18nLocale,
  weekDay: WeekOptionValues
): string => {
  switch (weekDay) {
    case 'sunday':
      return t(i18nLocale, 'integrations:weekDay.sunday', 'Sunday');
    case 'monday':
      return t(i18nLocale, 'integrations:weekDay.monday', 'Monday');
    case 'tuesday':
      return t(i18nLocale, 'integrations:weekDay.tuesday', 'Tuesday');
    case 'wednesday':
      return t(i18nLocale, 'integrations:weekDay.wednesday', 'Wednesday');
    case 'thursday':
      return t(i18nLocale, 'integrations:weekDay.thursday', 'Thursday');
    case 'friday':
      return t(i18nLocale, 'integrations:weekDay.friday', 'Friday');
    case 'saturday':
      return t(i18nLocale, 'integrations:weekDay.saturday', 'Saturday');
  }
};

export const getScheduleTypeLabel = (
  i18nLocale: I18nLocale,
  scheduleType: ScheduleType
): string => {
  switch (scheduleType) {
    case 'nightly':
      return t(i18nLocale, 'integrations:scheduleType.daily', 'Daily');
    case 'weekly':
      return t(i18nLocale, 'integrations:scheduleType.weekly', 'Weekly');
  }
};
